<div class="relative" data-test-id="mobile">
	<div
		#mobileHeaderEl
		[class]="
			cn(
				(languageIsOpen || ctaIsOpen) && '!z-10',
				isNegativeHeader() && !menuIsOpen && 'border-b-transparent',
				(!isNegativeHeader() || menuIsOpen) && 'border-b-ui-100',
				showBackground && 'bg-white'
			)
		"
		class="relative z-40 flex flex-col border-b px-4 py-6"
	>
		<div
			[class]="
				cn(
					!showBackground ? 'text-white' : 'text-black',
					title ? 'justify-between' : 'justify-end'
				)
			"
			class="flex sm:min-h-11"
		>
			@if (!hideMenu) {
				@if (title) {
					<vp-link
						[link]="logoLink"
						(linkClick)="closeMobileMenu()"
						className="flex transition-opacity duration-300 ease-out"
						data-test-id="header-logo"
						type="link-unstyled"
					>
						<ng-container [ngTemplateOutlet]="logo" />
					</vp-link>
				}
				<div class="ml-1 flex gap-x-4">
					<button
						(click)="toggleMenu()"
						class="flex text-sm uppercase"
						data-test-id="toggle-menu"
					>
						<span class="sr-only">{{
							'compositions.header.menu' | translate
						}}</span>
						<svg-icon
							[class]="
								cn(
									!showBackground
										? 'text-white'
										: 'text-dark-primary'
								)
							"
							[src]="
								menuIsOpen
									? 'assets/icons/icon-cross.svg'
									: 'assets/icons/icon-bars.svg'
							"
							class="block size-6"
						/>
					</button>
				</div>
			} @else {
				<span class="flex items-center" data-test-id="header-logo">
					<ng-container [ngTemplateOutlet]="logo" />
				</span>
			}
		</div>
	</div>
	<div
		#mobileMenuEl
		[class]="cn(menuIsOpen && 'block')"
		class="fixed left-0 top-0 z-30 size-full -translate-y-full overflow-hidden overflow-y-auto bg-white md:left-1/2"
		data-test-id="mobile-menu"
	>
		<ul class="flex h-fit flex-col justify-center">
			@for (menuItem of menuItems; track $index) {
				<li
					class="flex size-full items-center gap-2 border-b border-ui-100 px-3 py-2.5 text-lg"
					data-test-class="menu-item"
				>
					@if (menuItem.icon) {
						<svg-icon
							[src]="menuItem.icon"
							class="ml-2 size-4 grow-0 cursor-pointer text-black"
						/>
					}
					<vp-link
						[link]="menuItem"
						(linkClick)="closeMobileMenu()"
						class="flex flex-1"
						className="w-full"
						type="link-unstyled"
					>
						{{ menuItem.title }}
					</vp-link>
				</li>
			}
		</ul>
	</div>
	@if (metaMenu()) {
		<div
			#metaMenuEl
			class="fixed bottom-0 left-0 z-30 w-full translate-y-full overflow-hidden bg-white shadow-[rgba(0,0,0,0.1)_0px_0px_12px] md:left-[50%] md:w-1/2"
			data-test-id="bottom"
		>
			<div class="m-4">
				<div
					class="mb-4 flex w-full justify-center"
					data-test-id="meta-menu"
				>
					@if (metaMenu().logoutButton?.title) {
						<button
							class="flex w-full flex-1 flex-col items-center gap-1 p-0.5 text-sm leading-none"
						>
							<svg-icon
								[src]="metaMenu().logoutButton.icon"
								(click)="
									metaMenu().logoutButton.callback();
									closeMobileMenu()
								"
								class="block size-5 text-dark-primary"
							/>
							{{ metaMenu().logoutButton.title | translate }}
						</button>
					}
					@if (metaMenu().contactLink?.url) {
						<vp-link
							[link]="metaMenu().contactLink"
							(linkClick)="closeMobileMenu()"
							class="flex-1"
							className="flex w-full flex-col items-center gap-1 p-0.5 text-sm leading-none"
							type="link-unstyled"
						>
							<svg-icon
								class="block size-5 text-dark-primary"
								src="assets/icons/icon-phone-line.svg"
							/>
							{{ 'compositions.header.contact' | translate }}
						</vp-link>
					}
					@if (metaMenu().accountLink?.url) {
						<vp-link
							[link]="metaMenu().accountLink"
							(linkClick)="closeMobileMenu()"
							class="flex-1"
							className="flex w-full flex-col items-center gap-1 p-0.5 text-sm leading-none"
							type="link-unstyled"
						>
							<svg-icon
								class="block size-5 text-dark-primary"
								src="assets/icons/icon-person.svg"
							/>
							{{
								'compositions.header.account-mobile' | translate
							}}
						</vp-link>
					}
					@if (metaMenu().showSearch) {
						<button
							class="flex w-full flex-1 flex-col items-center gap-1 p-0.5 text-sm leading-none"
						>
							<svg-icon
								class="block size-5 text-dark-primary"
								src="assets/icons/icon-looking-glass.svg"
							/>
							{{ 'compositions.header.search' | translate }}
						</button>
					}
					@if (metaMenu().languages?.options) {
						<button
							(click)="toggleLanguageMenu()"
							class="flex w-full flex-1 flex-col items-center gap-1 p-0.5 text-sm leading-none"
							data-test-id="show-language-menu"
						>
							<svg-icon
								class="block size-5 text-dark-primary"
								src="assets/icons/icon-translate.svg"
							/>
							{{
								metaMenu().languages.selectedLanguageOption
									?.lang
							}}
						</button>
					}
				</div>

				@if (isCtaGroupResolved(); as cta) {
					<button
						(click)="toggleCtaMenu()"
						class="btn btn-primary btn-sm w-full"
						data-test-id="cta-button"
					>
						{{ cta.title }}
					</button>
				} @else if (isCtaItem(); as cta) {
					<vp-link
						[link]="cta"
						(linkClick)="closeMobileMenu()"
						class="flex"
						className="button h-fit w-full justify-center"
						data-test-id="cta-button"
						type="button"
					>
						{{ cta.title }}
					</vp-link>
				}
			</div>
		</div>
	}
	@if (metaMenu()?.languages) {
		<div
			#languageMenuEl
			class="fixed bottom-0 left-0 z-30 w-full translate-y-full"
			data-test-id="language-menu"
		>
			<vp-bottom-sheet
				[isOpen]="languageIsOpen"
				[preventNavigation]="true"
				[sheetItems]="languageOptionsForLinkList()"
				[sheetTitle]="'compositions.header.choose-language' | translate"
				(itemClicked)="switchLanguage($event.url)"
				(toggleSheet)="toggleLanguageMenu()"
			/>
		</div>
	}
	@if (isCtaGroupResolved(); as cta) {
		<div
			#ctaMenuEl
			class="fixed bottom-0 left-0 z-30 w-full translate-y-full"
			data-test-id="cta-menu"
		>
			<vp-bottom-sheet
				[isOpen]="ctaIsOpen"
				[sheetItems]="cta.items"
				[sheetTitle]="cta.title"
				(toggleSheet)="toggleCtaMenu()"
			/>
		</div>
	}
</div>

<div
	[class]="cn({ invisible: !menuIsOpen && !languageIsOpen && !ctaIsOpen })"
	class="overlay-dark-3 fixed left-0 top-0 z-20 size-full"
></div>

<ng-template #logo>
	<svg-icon
		[class]="cn(!showBackground ? 'text-white' : 'text-dark-primary')"
		[src]="'assets/logos/' + title + '.svg'"
		[svgStyle]="{ 'height.px': 24, width: 'auto' }"
	/>
</ng-template>
